import { Box, Icon, Tooltip } from '@branch-messenger/willow-ui'
import { AlertCircleFilled } from '@branch-messenger/willow-ui/icons'
import { useMediaQuery } from '@uidotdev/usehooks'
import { FC } from 'react'

import { PageSubTitle } from '@/components/page-title'
import { useOrg } from '@/selectors/organization'
import { mediaQueries } from '@/styles/media'

export const HeaderSubTitle: FC = () => {
  const isLargeTabletAndUp = useMediaQuery(mediaQueries.largeTabletAndUp)

  const {
    data: { orgName, hoursOrEarnings, withdrawalPercentage },
  } = useOrg()

  return (
    <Box $display="flex" $gap={1} $align="center">
      <PageSubTitle
        $bold
      >{`Based on reported ${hoursOrEarnings}`}</PageSubTitle>
      <Tooltip
        side={isLargeTabletAndUp ? 'right' : undefined}
        trigger={
          <Box $display="flex" $align="center">
            <Icon Icon={AlertCircleFilled} color="selection" />
          </Box>
        }
      >
        {`${orgName} reports your ${hoursOrEarnings} daily, allowing us to calculate your available earnings.
        You can access up to ${withdrawalPercentage * 100}% of your pay right away!`}
      </Tooltip>
    </Box>
  )
}
